export default () => {
  const triggers = document.querySelectorAll('.js-toggle')
  if (triggers.length < 1) return
  ;[...triggers].forEach(trigger => {
    trigger.addEventListener('click', e => {
      trigger.classList.toggle('active')
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Toggle.js